import {
  CLEAR_TSUNAMI_EVENT_INFO,
  GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST,
  GET_TSUNAMI_EVENT_INFO_REQUEST,
  TSUNAMI_EVENT_INFO_REFERENCE_SORT,
  TSUNAMI_EVENT_INFO_TOGGLE_COLUMN,
} from './tsunamiEventInfoReducer';

export const clearTsunamiEventInfo = () => ({ type: CLEAR_TSUNAMI_EVENT_INFO });
export const getTsunamiEventInfo = ({ id, history }) => ({ type: GET_TSUNAMI_EVENT_INFO_REQUEST, id, history });
export const getTsunamiEventReferences = ({ id, history }) => ({ type: GET_TSUNAMI_EVENT_INFO_REFERENCES_REQUEST, id, history });
export const sortReferences = sort => ({ type: TSUNAMI_EVENT_INFO_REFERENCE_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: TSUNAMI_EVENT_INFO_TOGGLE_COLUMN, visibleColumns });
